import { Injectable } from '@angular/core';

import { Observable, map } from 'rxjs';

import { GetProjectsParams, ProjectListFilterService, ProjectService } from '@mirage-projects/cw-commons';
import { CatalogObjectSelection, ObjectBrowserFilter, Project, ResultPage } from '@mirage-projects/cw-models';
import { JobPcvizService } from '@mirage-projects/cw-pcviz-core';

import { ObjectBrowserSelectionService } from '../object-browser/selection.service';

/**
 * Service that has the logic of the existing project component
 */
@Injectable({ providedIn: 'root' })
export class SelectExistingProjectService {
    constructor(
        private projectService: ProjectService,
        private selectionService: ObjectBrowserSelectionService,
        private jobAdapterService: JobPcvizService,
        private projectFilterService: ProjectListFilterService
    ) {}

    /**
     * Initialize the filters for the existing project list
     */
    initializeFilters(): ObjectBrowserFilter[] {
        const filters = this.projectFilterService.initFilters(true);

        if (this.jobAdapterService.getJobAdapter()?.getCategory()) {
            filters.push({
                queryField: 'category',
                value: this.jobAdapterService.getJobAdapter()?.getCategoryString(),
            });
        }

        return filters;
    }

    /**
     * Load the projects from the server using the pagination and filter passed
     * @param params Params to filter and paginate the projects
     * */
    loadProjects(params: Partial<GetProjectsParams>): Observable<ResultPage<CatalogObjectSelection>> {
        return this.projectService.getProjects(params).pipe(
            map((response: ResultPage<Project>) => {
                if (response?.count < 1) {
                    return { ...response, results: [] };
                }

                const results = response.results.map((item: any) => {
                    const isSelected = this.selectionService.isElementSelected(item, 'projects');

                    return {
                        catalogObject: item,
                        selected: isSelected,
                    };
                });

                return { ...response, results };
            })
        );
    }
}
